import React from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Header from '../../../component/common/LeaveHeader';
import Loader from '../../../component/common/Loader';
import CONSTANT from '../../../constant';

import { updateUserLeave, getUserLeaveSummary } from '../../../actions/LeaveAction'

class ComponentName extends React.Component<any, any>{
   
     constructor(props: any) {
        super(props);
        const value = queryString.parse(this.props.location.search);
        this.state = {
            userCode: value.code,
            leaveDetailArr: [],
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
        this.loadLeaveSummary()
    }

    render() {
        const { leaveDetailArr, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Manage leave</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                {
                                                    leaveDetailArr.map((item: any, index: number) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <div className="col-md-6" key={index}>
                                                                    <div className="form-group">
                                                                        <label>{item.name} Used</label>
                                                                        <input
                                                                            type="number"
                                                                            data-type={item.code}
                                                                            data-item-type="u"
                                                                            className={item.used.length === 0 ? 'form-control is-invalid' : 'form-control'}
                                                                            placeholder={`# of ${item.name}`}
                                                                            name={item.name}
                                                                            value={item.used}
                                                                            onChange={this.onArrayItemChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6" >
                                                                    <div className="form-group">
                                                                        <label>{item.name} Total</label>
                                                                        <input
                                                                            type="number"
                                                                            data-type={item.code}
                                                                            data-item-type="t"
                                                                            className={item.total.length === 0 ? 'form-control is-invalid' : 'form-control'}
                                                                            placeholder={`# of ${item.name}`}
                                                                            name={item.name}
                                                                            value={item.total}
                                                                            onChange={this.onArrayItemChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <Link to={CONSTANT.component.unitLeaveReport.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                                </div>
                                                <div className="col-md-6">
                                                    &nbsp;
                                                </div>
                                                <div className="col-md-3">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onArrayItemChange = (e: any) => {
        const value = parseFloat(e.target.value);
        const type = parseFloat(e.target.dataset.type);
        const usedOrTotal = e.target.dataset.itemType;
        const _tempArr = JSON.parse(JSON.stringify(this.state.leaveDetailArr));
        const updatedArr = _tempArr.map((i: any) => {
            if (i.code === type) {
                if (usedOrTotal === 'u') {
                    i.used = value;
                } else {
                    i.total = value;
                }

            }
            return i;
        });
        this.setState({ leaveDetailArr: [...updatedArr] });
    }

    loadLeaveSummary = () => {
        this.setState({ showLoader: true });
        const { userCode } = this.state;
        getUserLeaveSummary(userCode).then((res: any) => {
            const filtered = res.result.leaveTypeList.filter((i: any) => i.code !== CONSTANT.static.leaveType.cml);
            this.setState({ showLoader: false, leaveDetailArr: filtered });
        });
    }

    onSubmit = (e: any) => {
        e.preventDefault();

        if (this.validateForm() && !this.state.showLoader) {
            this.setState({ showLoader: true });
            const { leaveDetailArr, userCode, year } = this.state;
            const model = {
                leaveBalance: leaveDetailArr,
                userCode,
                year: Number(year)
            };

            updateUserLeave(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res) {
                    if (res.status === CONSTANT.static.apiStatus.success) {
                        alert('Leave updated successfully');
                        this.props.history.push(CONSTANT.component.unitLeaveReport.url);
                    } else {
                        alert(res.error);
                    }
                }
            });
        }
    }

    validateForm = () => {
        const { leaveDetailArr } = this.state;
        const result = leaveDetailArr.filter((i: any) => {
            if (i.total.length === 0) {
                return i;
            }
        });
        return result.length > 0 ? false : true;
    }
}

export default ComponentName;